import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { Store, select } from '@ngrx/store';
import { AppState } from '../../../store/core.state';
import { environment } from '../../../../environments/environment';
import { selectLoading } from '../../../store/core.selector';
import { MatProgressBar } from '@angular/material/progress-bar';
import { MatTooltip } from '@angular/material/tooltip';
import { RouterLink } from '@angular/router';
import { MatIcon } from '@angular/material/icon';
import { MatToolbar } from '@angular/material/toolbar';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    imports: [MatToolbar, MatIcon, RouterLink, MatTooltip, MatProgressBar]
})
export class HeaderComponent implements OnInit, OnDestroy {
  loading:boolean;
  unsubscribe$: Subject<void> = new Subject();
  appversion: string = environment.appVersion;

  constructor(private store: Store<AppState>) {}
  
  ngOnInit(): void {
    this.store.pipe(select(selectLoading), takeUntil(this.unsubscribe$))
      .subscribe( loading => this.loading = loading);
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  } 
}
